<template>
        <div class="bg-wrap">
            <div class="kv">
            </div>
             <div class="content-wrap">
                    <span>{{title}}</span>
                    <div class="content-wrap-but">
<!--                            <div class="item" @click="toAnswerBtn(1)" v-if="qStation==0||qStation==1">-->
<!--                                    <span>{{one}}</span>-->
<!--                                    <img src="../../assets/img/answer_index_btn1.png">-->
<!--                                    <label>{{label_1}}</label>-->
<!--                            </div>-->

<!--                            <div class="item item-1" v-if="qStation==-1">-->
<!--                                <span>{{one}}</span>-->
<!--                                <img src="../../assets/img/answer_index_btn1.png">-->
<!--                                <label>{{label_1}}</label>-->
<!--                            </div>-->

                            <div class="item" @click="toAnswerBtn(2)">
                                    <span>{{one}}</span>
                                    <img src="../../assets/img/answer_index_btn2.png">
                                    <label>{{label_2}}</label>
                            </div>

                    </div>
             </div>
        </div>
</template>

<script>
    import {answerPlayerQuestionStation} from "../../assets/js/api";

    export default {
        data(){
            return{
                title:"共话新知",
                one:1,
                two:2,
                label_1:"必答题",
                label_2:"竞答题",
                qStation:0
            }
        },
        methods:{
            toAnswerBtn(type){
                switch (type) {
                    case 1:
                        if(this.qStation==0){//题目未选
                            this.$router.push({path:"/playerRegAnswerBtn",query:{"type":1}})
                        }else{//题目已选择
                            this.$router.push({path:"/playerRegAnswer",query:{"type":1}})
                        }
                        break
                    case 2:
                        this.$router.push({path:"/playerCompAnswerBtn",query:{"type":2}})
                        break
                }
            },
            async questionStation(playerId,type){
                const res = await answerPlayerQuestionStation({playerId,type})
                console.log(res,"in")
                if(res.data.success==true){
                    this.qStation = res.data.data
                }
            }
        },
        mounted(){
           let playerId =  this.$store.state.playerId;
            console.log(playerId,"platerId====")
           this.questionStation(playerId,1)
        }

    }
</script>

<style scoped lang="scss">
    .bg-wrap{
        width: 100%;
        /*max-width: 375px;*/
        height: 100vh;
        background: #FFF url("../../assets/img/answer_bg.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .content-wrap{
        display: flex;
        flex-flow: column;
        align-items: center;
    }
    .content-wrap >span{
        color: #FFF;
        font-size: 38px;
        font-weight: bold;
        font-style: italic;
        letter-spacing: 3px;
    }

    .content-wrap-but{
        width: 100%;
        margin-top: 30px;
        display: flex;
        flex-flow: row;
        justify-content: space-around;
    }

    .content-wrap-but .item-1{
        opacity: 0.4;
    }

    .content-wrap-but .item{
        width: 120px;
        height: 120px;
        background: #FFF;
        border-radius: 15px;
        position: relative;
        span{
            font-size: 56px;
            color: #C12935;
            font-weight: bold;
            position: absolute;
            left: 5px;
            top: 0px;
        }
        img{
            position: absolute;
            right: 10px;
            top:15px;
            width: 28px;
            height: 35px;
        }

        label{
            position: absolute;
            right: 15px;
            bottom: 5px;
            font-size: 25px;
            color: #C12935;
            font-weight: bold;
            /*font-style: italic;*/

        }


    }



</style>